import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import validateEmail from '../../validateEmail';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ShowChart from '@material-ui/icons/ShowChart';
import Brightness1 from '@material-ui/icons/Brightness1';
import Crop169 from '@material-ui/icons/Crop169';
import { ReportBugs, Line, Circle, Point, Polygon, Clear } from '../icons/index';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import PanoramaFishEye from '@material-ui/icons/PanoramaFishEye';
import ContentPanel from '../contentPanel/index';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';


const styles = theme => ({
  inputLabel: {
    fontSize: '0.8em'
  },
  input: {fontSize: '1.2em'},
  mapMistakes: {
    minWidth: '296px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  textField: {
    width: '100%',
  },
  icon: {
    width: '35px',
    height: '35px'
  },
  buttonSubmit: {
    backgroundColor: '#a01934',
    fontSize: '0.8em',
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.action.hoverText
    }
  },
  mapBttIcon: {
    width: '30px',
    height: '30px',
  }
});

class MapMistakes extends Component {
  state = {
    description: '',
    name: '',
    email: '',
    invalidFields: []
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }
  verify = data => {

    var state = this.state;
    state.invalidFields = [];

    if(data.description == "") {
      
      state.invalidFields.push('description');
      this.setState(state);
    }

    if(data.email !== "" && !validateEmail(data.email)) {
      
      state.invalidFields.push('email');
      this.setState(state);
    }

    if(state.invalidFields.length == 0) {

      return true;
    } else {

      return false;
    }
    
  }
  handleSubmit = data => {

    if(this.verify(this.state)){
      this.props.submitHandler(Object.assign(this.state, {mapurl: this.props.mapurl}));
      this.setState({
        description: '',
        name: '',
        email: '',
        invalidFields: []
      });
    }
  }
  render() {

      const { classes, enabled } = this.props;
      const startedSending = this.props.contentPanelProps.started;
      
      if(!enabled) {
        return null;
      }
      
      return (
        <ContentPanel
            HeaderIcon={<ReportBugs className={classes.icon} />}
            enabled={this.props.enabled}
            HeaderText= {window.displayText('MAP_MISTAKES')}
            onClose= {this.props.closeHandler}
            formState={this.props.contentPanelProps.formState}
            finMessage={this.props.contentPanelProps.finMessage}
            StartNewHandler={this.props.StartNewHandler}
        >
            <div className={classes.mapMistakes}>
              <div>
                <IconButton color="primary" onClick={this.props.handleDraw('LineString')} className={classes.button}>
                  <Line className={classes.mapBttIcon} />
                </IconButton>
              </div>
              <div>
                <IconButton color="primary" onClick={this.props.handleDraw('Point')} className={classes.button}>
                  <Point  className={classes.mapBttIcon} />
                </IconButton>
              </div>
              <div>
                <IconButton color="primary" onClick={this.props.handleDraw('Polygon')} className={classes.button}>
                  <Polygon  className={classes.mapBttIcon} />
                </IconButton>
              </div>
              <div>
                <IconButton color="primary" onClick={this.props.handleDraw('Clear')} className={classes.button}>
                  <Clear className={classes.mapBttIcon} />
                </IconButton>
              </div>
            </div>
            <div>
            <FormControl  margin="normal" className={classes.textField}>
              <InputLabel className={classes.inputLabel} htmlFor="map-field-mm">{window.displayText('MAP_LINK')}</InputLabel>
              <Input className={classes.input} disabled id="map-field-mm" value={this.props.mapurl} onChange={this.handleChange('name')} />
            </FormControl>
            </div>
            <div>
              <FormControl  margin="normal" className={classes.textField}>
                <InputLabel className={classes.inputLabel} htmlFor="map-field-mm">{window.displayText('NAME')}</InputLabel>
                <Input className={classes.input} id="name-field-mm" value={this.state.name} onChange={this.handleChange('name')} />
              </FormControl>
            </div>
            <div>
              <FormControl  margin="normal" className={classes.textField} error={(this.state.invalidFields.indexOf('email') > -1 ? true : false)}>
                <InputLabel className={classes.inputLabel} htmlFor="map-field-mm">{window.displayText('EMAIL')}</InputLabel>
                <Input className={classes.input} id="email-field-mm" value={this.state.email} onChange={this.handleChange('email')} />
                  {this.state.invalidFields.indexOf('email') > -1 ? (<FormHelperText id="name-error-text">{window.displayText('INVALID_EMAIL')}</FormHelperText>) : ""}
              </FormControl>
            </div>
            <div>
            <FormControl  margin="normal" className={classes.textField} error={(this.state.invalidFields.indexOf('description') > -1 ? true : false)}>
                <InputLabel className={classes.inputLabel} htmlFor="descr-field-mm">{window.displayText('MAP_MISTAKE_DESCRIPTION')}*</InputLabel>
                <Input className={classes.input}
                  multiline
                  rows="4"
                  id="descr-field-mm" 
                  value={this.state.description} onChange={this.handleChange('description')} />
                  {this.state.invalidFields.indexOf('description') > -1 ? (<FormHelperText id="name-error-text">{window.displayText('FORM_MANDATORY_FIELD')}</FormHelperText>) : ""}
              </FormControl>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <Button variant="contained" disabled={startedSending ? true : false} component="span" onClick={this.handleSubmit} className={classes.buttonSubmit}>
                {startedSending ? "..." : window.displayText('SUBMIT')}
              </Button>
            </div>
        </ContentPanel>
      );
  }
}

MapMistakes.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  submitHandler: PropTypes.func.isRequired,
  handleDraw: PropTypes.func.isRequired,
  mapurl: PropTypes.string,
  closeHandler: PropTypes.func.isRequired,
  contentPanelProps: PropTypes.object,
  StartNewHandler: PropTypes.func
};

export default withStyles(styles)(MapMistakes);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/mapMistakes/index.js